import React, { useState } from "react";
import { Button, Checkbox } from "semantic-ui-react";
import { fileJob } from '../../commonApis'
import { LoaderPopup } from '../LoaderPopup'
import { confirmAlert } from 'react-confirm-alert'

const SendArrivalNoticeButton = (props) => {
  const [fileWithES, setFileWithES] = useState(false);
  const shipId = props.shipId || window.shipmentId
  //const islegalNoteAccepted = props.legalAcknowledgementAccepted;

  const [toggleLoader, setToggleLoader] = useState(false)
  const [loaderMsg, setLoaderMessage] = useState('Processing...')

  const toggleLoaderFunc = (msg, timer) => {
    //
    var time = timer || 3000
    setToggleLoader(true)
    setLoaderMessage(msg)
    setTimeout(() => {
      setToggleLoader(false)
      setLoaderMessage('Loading...')
    }, time)
  }

  const fileClickHandler = async () => {
    await toggleLoaderFunc("Sending Arrival notification...")
    let payload = {
      shipmentId: shipId,
      countryCode: "GB",
      mockRequest: !fileWithES,
      import: true,
      formType: "CDS_ARRIVAL_NOTIFICATION",
      eventType: `FILE_FORM_GB`,
    }
    const res = await fileJob(payload);
    await toggleLoaderFunc("Please wait...")
    if (res?.data?.eventMessage?.code === 400) {
      await toggleLoaderFunc("Failed to send notification, something went wrong.")
    } else {
      await toggleLoaderFunc(res?.data?.eventMessage?.msg);
    }
    await document.getElementById(`card-${shipId}`).click();
  }

  const sendArrivalClicked = async () => {
    let msg = "Are you sure you want to send the Arrival Notification?"
    confirmAlert({
      title: "Confirmation",
      message: msg,
      buttons: [
        {
          label: 'CANCEL',
          onClick: () => {
            return false
          },
        },
        {
          label: 'OK',
          onClick: async () => {
            await fileClickHandler()
          },
        },
      ],
    })
  }
  return (
    <><Button.Group>
      {props.lowerEnv[0] !== 'prod' && <Checkbox
        key="uatFiling"
        id="returnToEdit"
        className="fileWithES"
        checked={fileWithES}
        label={`SEND WITH SANDBOX`}
        onChange={(event) => {
          let chk = event.target.checked ? true : false
          setFileWithES(chk)
        }}
      />}
      <Button
        size="mini"
        key="FILE_ARRIVAL_NOTICE"
        className="sv todo-button secondaryBtn"
        onClick={(e) => {
          e.stopPropagation();
          sendArrivalClicked();
        }}
      >
        {`SEND ARRIVAL NOTICE`}
      </Button>
    </Button.Group>
      {toggleLoader && <LoaderPopup loaderMsg={loaderMsg} />}
    </>
  );
}

export default SendArrivalNoticeButton;